// source: acompanha/replacement_parts/v1/replacement_parts.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.GetReplacementPartRequest', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.GetReplacementPartResponse', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.ReplacementPartItem', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.ReplacementPartsStats', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.StockExtremeItem', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.StockUsage', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest', null, global);
goog.exportSymbol('proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.replacement_parts.v1.ReplacementPartItem.repeatedFields_, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.ReplacementPartItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.ReplacementPartItem.displayName = 'proto.acompanha.replacement_parts.v1.ReplacementPartItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.StockUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.StockUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.StockUsage.displayName = 'proto.acompanha.replacement_parts.v1.StockUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.StockExtremeItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.StockExtremeItem.displayName = 'proto.acompanha.replacement_parts.v1.StockExtremeItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.replacement_parts.v1.ReplacementPartsStats.repeatedFields_, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.ReplacementPartsStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.ReplacementPartsStats.displayName = 'proto.acompanha.replacement_parts.v1.ReplacementPartsStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.displayName = 'proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.displayName = 'proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.GetReplacementPartRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.displayName = 'proto.acompanha.replacement_parts.v1.GetReplacementPartRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.GetReplacementPartResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.displayName = 'proto.acompanha.replacement_parts.v1.GetReplacementPartResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.displayName = 'proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.displayName = 'proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.displayName = 'proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.displayName = 'proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.displayName = 'proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.ReplacementPartItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
unitValueCents: jspb.Message.getFieldWithDefault(msg, 4, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 5, 0),
stockValueCents: jspb.Message.getFieldWithDefault(msg, 6, 0),
printerBrand: jspb.Message.getFieldWithDefault(msg, 7, ""),
printerModel: jspb.Message.getFieldWithDefault(msg, 8, ""),
appliesToAllPrinters: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
usagesList: jspb.Message.toObjectList(msg.getUsagesList(),
    proto.acompanha.replacement_parts.v1.StockUsage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.ReplacementPartItem;
  return proto.acompanha.replacement_parts.v1.ReplacementPartItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnitValueCents(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStockValueCents(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterBrand(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModel(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAppliesToAllPrinters(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 13:
      var value = new proto.acompanha.replacement_parts.v1.StockUsage;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.StockUsage.deserializeBinaryFromReader);
      msg.addUsages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.ReplacementPartItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUnitValueCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getStockValueCents();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPrinterBrand();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPrinterModel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAppliesToAllPrinters();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUsagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.acompanha.replacement_parts.v1.StockUsage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 unit_value_cents = 4;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getUnitValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setUnitValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 quantity = 5;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 stock_value_cents = 6;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getStockValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setStockValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string printer_brand = 7;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getPrinterBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setPrinterBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string printer_model = 8;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getPrinterModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setPrinterModel = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool applies_to_all_printers = 10;
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getAppliesToAllPrinters = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setAppliesToAllPrinters = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
*/
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
*/
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated StockUsage usages = 13;
 * @return {!Array<!proto.acompanha.replacement_parts.v1.StockUsage>}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.getUsagesList = function() {
  return /** @type{!Array<!proto.acompanha.replacement_parts.v1.StockUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.replacement_parts.v1.StockUsage, 13));
};


/**
 * @param {!Array<!proto.acompanha.replacement_parts.v1.StockUsage>} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
*/
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.setUsagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.StockUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.addUsages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.acompanha.replacement_parts.v1.StockUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartItem.prototype.clearUsagesList = function() {
  return this.setUsagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.StockUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.StockUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.StockUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
quantity: jspb.Message.getFieldWithDefault(msg, 1, 0),
usedAt: (f = msg.getUsedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
printerName: jspb.Message.getFieldWithDefault(msg, 3, ""),
maintenanceUuid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage}
 */
proto.acompanha.replacement_parts.v1.StockUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.StockUsage;
  return proto.acompanha.replacement_parts.v1.StockUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.StockUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage}
 */
proto.acompanha.replacement_parts.v1.StockUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUsedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaintenanceUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.StockUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.StockUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.StockUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUsedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPrinterName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMaintenanceUuid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 quantity = 1;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage} returns this
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp used_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.getUsedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage} returns this
*/
proto.acompanha.replacement_parts.v1.StockUsage.prototype.setUsedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage} returns this
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.clearUsedAt = function() {
  return this.setUsedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.hasUsedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string printer_name = 3;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.getPrinterName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage} returns this
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.setPrinterName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string maintenance_uuid = 4;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.getMaintenanceUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.StockUsage} returns this
 */
proto.acompanha.replacement_parts.v1.StockUsage.prototype.setMaintenanceUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.StockExtremeItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.StockExtremeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.StockExtremeItem}
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.StockExtremeItem;
  return proto.acompanha.replacement_parts.v1.StockExtremeItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.StockExtremeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.StockExtremeItem}
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.StockExtremeItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.StockExtremeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.StockExtremeItem} returns this
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 quantity = 2;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.StockExtremeItem} returns this
 */
proto.acompanha.replacement_parts.v1.StockExtremeItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.ReplacementPartsStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.toObject = function(includeInstance, msg) {
  var f, obj = {
totalItems: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalStockValueCents: jspb.Message.getFieldWithDefault(msg, 2, 0),
highestStockList: jspb.Message.toObjectList(msg.getHighestStockList(),
    proto.acompanha.replacement_parts.v1.StockExtremeItem.toObject, includeInstance),
lowestStockList: jspb.Message.toObjectList(msg.getLowestStockList(),
    proto.acompanha.replacement_parts.v1.StockExtremeItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.ReplacementPartsStats;
  return proto.acompanha.replacement_parts.v1.ReplacementPartsStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalStockValueCents(value);
      break;
    case 3:
      var value = new proto.acompanha.replacement_parts.v1.StockExtremeItem;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.StockExtremeItem.deserializeBinaryFromReader);
      msg.addHighestStock(value);
      break;
    case 4:
      var value = new proto.acompanha.replacement_parts.v1.StockExtremeItem;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.StockExtremeItem.deserializeBinaryFromReader);
      msg.addLowestStock(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.ReplacementPartsStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalStockValueCents();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getHighestStockList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.acompanha.replacement_parts.v1.StockExtremeItem.serializeBinaryToWriter
    );
  }
  f = message.getLowestStockList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.acompanha.replacement_parts.v1.StockExtremeItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 total_items = 1;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_stock_value_cents = 2;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.getTotalStockValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.setTotalStockValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated StockExtremeItem highest_stock = 3;
 * @return {!Array<!proto.acompanha.replacement_parts.v1.StockExtremeItem>}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.getHighestStockList = function() {
  return /** @type{!Array<!proto.acompanha.replacement_parts.v1.StockExtremeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.replacement_parts.v1.StockExtremeItem, 3));
};


/**
 * @param {!Array<!proto.acompanha.replacement_parts.v1.StockExtremeItem>} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} returns this
*/
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.setHighestStockList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.StockExtremeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.replacement_parts.v1.StockExtremeItem}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.addHighestStock = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.replacement_parts.v1.StockExtremeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.clearHighestStockList = function() {
  return this.setHighestStockList([]);
};


/**
 * repeated StockExtremeItem lowest_stock = 4;
 * @return {!Array<!proto.acompanha.replacement_parts.v1.StockExtremeItem>}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.getLowestStockList = function() {
  return /** @type{!Array<!proto.acompanha.replacement_parts.v1.StockExtremeItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.replacement_parts.v1.StockExtremeItem, 4));
};


/**
 * @param {!Array<!proto.acompanha.replacement_parts.v1.StockExtremeItem>} value
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} returns this
*/
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.setLowestStockList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.StockExtremeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.replacement_parts.v1.StockExtremeItem}
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.addLowestStock = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.replacement_parts.v1.StockExtremeItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartsStats} returns this
 */
proto.acompanha.replacement_parts.v1.ReplacementPartsStats.prototype.clearLowestStockList = function() {
  return this.setLowestStockList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
printerBrand: jspb.Message.getFieldWithDefault(msg, 2, ""),
printerModel: jspb.Message.getFieldWithDefault(msg, 3, ""),
inStockOnly: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
outOfStockOnly: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest;
  return proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterBrand(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModel(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInStockOnly(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOutOfStockOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getPrinterBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPrinterModel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInStockOnly();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOutOfStockOnly();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} returns this
*/
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string printer_brand = 2;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.getPrinterBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.setPrinterBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string printer_model = 3;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.getPrinterModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.setPrinterModel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool in_stock_only = 4;
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.getInStockOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.setInStockOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool out_of_stock_only = 5;
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.getOutOfStockOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsRequest.prototype.setOutOfStockOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.replacement_parts.v1.ReplacementPartItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f),
stats: (f = msg.getStats()) && proto.acompanha.replacement_parts.v1.ReplacementPartsStats.toObject(includeInstance, f),
archivedTotal: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse;
  return proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.replacement_parts.v1.ReplacementPartItem;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.ReplacementPartItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = new proto.acompanha.replacement_parts.v1.ReplacementPartsStats;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.ReplacementPartsStats.deserializeBinaryFromReader);
      msg.setStats(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArchivedTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.replacement_parts.v1.ReplacementPartItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
  f = message.getStats();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.acompanha.replacement_parts.v1.ReplacementPartsStats.serializeBinaryToWriter
    );
  }
  f = message.getArchivedTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated ReplacementPartItem items = 1;
 * @return {!Array<!proto.acompanha.replacement_parts.v1.ReplacementPartItem>}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.replacement_parts.v1.ReplacementPartItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.replacement_parts.v1.ReplacementPartItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.replacement_parts.v1.ReplacementPartItem>} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} returns this
*/
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.replacement_parts.v1.ReplacementPartItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.replacement_parts.v1.ReplacementPartItem}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.replacement_parts.v1.ReplacementPartItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} returns this
*/
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ReplacementPartsStats stats = 3;
 * @return {?proto.acompanha.replacement_parts.v1.ReplacementPartsStats}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.getStats = function() {
  return /** @type{?proto.acompanha.replacement_parts.v1.ReplacementPartsStats} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.replacement_parts.v1.ReplacementPartsStats, 3));
};


/**
 * @param {?proto.acompanha.replacement_parts.v1.ReplacementPartsStats|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} returns this
*/
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.setStats = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.clearStats = function() {
  return this.setStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.hasStats = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 archived_total = 4;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.getArchivedTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse} returns this
 */
proto.acompanha.replacement_parts.v1.ListReplacementPartsResponse.prototype.setArchivedTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.GetReplacementPartRequest;
  return proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.GetReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.replacement_parts.v1.ReplacementPartItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.GetReplacementPartResponse;
  return proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.replacement_parts.v1.ReplacementPartItem;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.ReplacementPartItem.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.replacement_parts.v1.ReplacementPartItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReplacementPartItem data = 1;
 * @return {?proto.acompanha.replacement_parts.v1.ReplacementPartItem}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.replacement_parts.v1.ReplacementPartItem} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.replacement_parts.v1.ReplacementPartItem, 1));
};


/**
 * @param {?proto.acompanha.replacement_parts.v1.ReplacementPartItem|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse} returns this
*/
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.GetReplacementPartResponse} returns this
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.GetReplacementPartResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
unitValueCents: jspb.Message.getFieldWithDefault(msg, 2, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
printerBrand: jspb.Message.getFieldWithDefault(msg, 4, ""),
printerModel: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest;
  return proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnitValueCents(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterBrand(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnitValueCents();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPrinterBrand();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPrinterModel();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 unit_value_cents = 2;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.getUnitValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.setUnitValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 quantity = 3;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string printer_brand = 4;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.getPrinterBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.setPrinterBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string printer_model = 5;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.getPrinterModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartRequest.prototype.setPrinterModel = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.replacement_parts.v1.ReplacementPartItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse;
  return proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.replacement_parts.v1.ReplacementPartItem;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.ReplacementPartItem.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.replacement_parts.v1.ReplacementPartItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReplacementPartItem data = 1;
 * @return {?proto.acompanha.replacement_parts.v1.ReplacementPartItem}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.replacement_parts.v1.ReplacementPartItem} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.replacement_parts.v1.ReplacementPartItem, 1));
};


/**
 * @param {?proto.acompanha.replacement_parts.v1.ReplacementPartItem|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse} returns this
*/
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse} returns this
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.CreateReplacementPartResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
unitValueCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
printerBrand: jspb.Message.getFieldWithDefault(msg, 5, ""),
printerModel: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest;
  return proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnitValueCents(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuantity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterBrand(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterModel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUnitValueCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPrinterBrand();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPrinterModel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 unit_value_cents = 3;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.getUnitValueCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.setUnitValueCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 quantity = 4;
 * @return {number}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string printer_brand = 5;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.getPrinterBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.setPrinterBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string printer_model = 6;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.getPrinterModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartRequest.prototype.setPrinterModel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.replacement_parts.v1.ReplacementPartItem.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse;
  return proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.replacement_parts.v1.ReplacementPartItem;
      reader.readMessage(value,proto.acompanha.replacement_parts.v1.ReplacementPartItem.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.replacement_parts.v1.ReplacementPartItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReplacementPartItem data = 1;
 * @return {?proto.acompanha.replacement_parts.v1.ReplacementPartItem}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.replacement_parts.v1.ReplacementPartItem} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.replacement_parts.v1.ReplacementPartItem, 1));
};


/**
 * @param {?proto.acompanha.replacement_parts.v1.ReplacementPartItem|undefined} value
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse} returns this
*/
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse} returns this
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.replacement_parts.v1.UpdateReplacementPartResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest;
  return proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest}
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest} returns this
 */
proto.acompanha.replacement_parts.v1.DeleteReplacementPartRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.replacement_parts.v1);
